/* Delivery estimate on product pages: detects the visitor's country from their IP (Shopify's
   browsing-context endpoint), then shows shipping cost, the free-shipping threshold, an
   estimated delivery window and duties notes for that country. The visitor can change country.
   Rates and countries mirror Settings > Shipping (profiles "Trendsi Shipping" and "MOFS — US only"). */
(() => {
  const eta = document.querySelector('.facts [data-eta]');
  const box = eta && eta.closest('.facts > div');
  const page = document.querySelector('[data-product-page]');
  if (!box || !page) return;
  box.classList.add('se');
  const origin = page.dataset.origin || 'overseas';            // us | la | overseas (product tags)
  const FR = window.FR || {};

  // zone: rate and free-from in USD; days = business days in transit (supplier figures)
  const Z = {
    us:   { rate: 6.95,  free: 85,  label: 'United States' },
    eu:   { rate: 8.95,  free: 99 },
    cao:  { rate: 7.95,  free: 99 },
    intl: { rate: 14.95, free: 149 }
  };
  const C = {
    US:['us'],
    AT:['eu',10,16],BE:['eu',8,14],BG:['eu',9,14],HR:['eu',14,16],CY:['eu',14,16],CZ:['eu',12,14],DK:['eu',12,14],
    EE:['eu',14,16],FI:['eu',18,20],FR:['eu',8,14],DE:['eu',8,14],GR:['eu',14,16],HU:['eu',10,16],IE:['eu',10,12],
    IT:['eu',8,14],LV:['eu',14,16],LT:['eu',14,16],LU:['eu',12,14],MT:['eu',12,14],NL:['eu',8,14],PL:['eu',9,14],
    PT:['eu',11,18],RO:['eu',12,14],SK:['eu',12,14],SI:['eu',12,14],ES:['eu',9,14],SE:['eu',11,16],GB:['eu',4,14],AL:['eu',11,14],
    CA:['cao',8,14],AU:['cao',8,16],NZ:['cao',8,14],
    JP:['intl',7,12],MX:['intl',7,12],SG:['intl',4,9],AE:['intl',9,16],SA:['intl',7,14],IL:['intl',14,17],
    MA:['intl',8,14],NG:['intl',15,20],PK:['intl',11,16],BR:['intl',16,29]
  };
  const names = (() => { try { return new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) { return null; } })();
  const nameOf = cc => (names && names.of(cc)) || cc;
  const flag = cc => cc.length === 2 ? String.fromCodePoint(...[...cc].map(c => 127397 + c.charCodeAt(0))) : '';

  // money in the visitor's active currency (Shopify converts at checkout with the same rate)
  const cur = (window.Shopify && Shopify.currency) || { active: 'USD', rate: '1' };
  const fmt = usd => {
    const v = usd * parseFloat(cur.rate || 1);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur.active, maximumFractionDigits: v % 1 ? 2 : 0 }).format(v); }
    catch (e) { return '$' + v.toFixed(2); }
  };
  const addBD = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w < 6) k++; } return d; };
  const day = d => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const proc = (FR.processing || [1, 3]);                         // business days to prepare the order

  // the returns row under the estimate: US wording from theme settings; outside the US our partners
  // take returns in the US only, so the row says what applies in the chosen country (see Refund policy)
  const retRow = box.nextElementSibling && box.nextElementSibling.querySelector('.ph-arrow-u-up-left') ? box.nextElementSibling.querySelector('span') : null;
  const retBox = retRow && retRow.parentElement;
  const sup = (retBox && retBox.dataset.sup) || 'trendsi';                 // trendsi | mofs | meridge
  const retUS = retRow ? retRow.innerHTML : '';
  const pol = '&nbsp;<a href="/policies/refund-policy" style="text-decoration:underline">Full policy</a>';
  const setReturns = (cc, zone) => {
    if (!retRow || retBox.hasAttribute('data-final')) return;              // final sale: same everywhere
    if (!zone || zone === 'us' || sup === 'mofs') { retRow.innerHTML = retUS; return; }   // MOFS ships to the US only
    const where = nameOf(cc);
    let t;
    if (zone === 'eu') t = `Returns from ${where}: you can cancel within 14 days of delivery, unworn with tags, for a refund. Return postage is paid by you.`;
    else if (sup === 'meridge') t = `Returns from ${where}: within 14 days of delivery, unworn with tags, for store credit or an exchange (10% restocking fee). Return postage and any customs charges are yours. Damaged or wrong pieces are refunded in full.`;
    else t = `Returns from ${where}: our partner warehouse takes returns from the US only, so we can't accept change-of-mind returns. If a piece arrives damaged or wrong, we refund it.`;
    retRow.innerHTML = t + pol;
  };
  // MERIDGE pieces: the partner's own delivery times (business days in transit) and rates at checkout
  const MER = { us: [5, 12], eu: [7, 15], cao: [7, 15], intl: [8, 20] };

  const render = cc => {
    const row = C[cc];
    setReturns(cc, row && row[0]);
    const sel = `<label class="se-pick"><span class="visually-hidden">Ship to</span><select data-se-country>${
      ['US', ...Object.keys(C).filter(k => k !== 'US').sort((a, b) => nameOf(a).localeCompare(nameOf(b)))]
        .map(k => `<option value="${k}"${k === cc ? ' selected' : ''}>${nameOf(k)}</option>`).join('')
      }${row ? '' : `<option value="${cc}" selected>${nameOf(cc)}</option>`}</select><i class="ph-light ph-caret-down" aria-hidden="true"></i></label>`;
    let html;
    if (!row) {
      html = `<b>We don't deliver to ${nameOf(cc)} yet</b><span>We currently ship to the US, Europe, the UK, Canada, Australia, New Zealand and selected countries.</span>`;
    } else if (origin === 'meridge') {
      const d = MER[row[0]];
      const duty = row[0] === 'us' ? '' : `<span class="se-duty"><i class="ph-light ph-info" aria-hidden="true"></i>Import duties and taxes, if any, are charged by ${nameOf(cc)}'s customs on delivery and are not included in our prices.</span>`;
      html = `<b>Delivery to ${nameOf(cc)}: ${day(addBD(d[0] + 1))} to ${day(addBD(d[1] + 3))}</b>`
           + `<span>Shipping cost is shown at checkout. Tracked from dispatch, about ${d[0]} to ${d[1]} business days in transit.</span>${duty}`;
    } else if (row[0] !== 'us' && origin !== 'overseas') {
      html = `<b>This piece ships within the US only</b><span>It's sent from our US partner. Most of our clothing does ship to ${nameOf(cc)}.</span>`;
    } else {
      const z = Z[row[0]];
      let min, max;
      if (row[0] === 'us') { const r = (FR.shipDays || {})[origin] || [5, 9]; min = r[0]; max = r[1]; }
      else { min = row[1] + proc[0]; max = row[2] + proc[1]; }
      const cost = `${fmt(z.rate)} shipping, free over ${fmt(z.free)}`;
      const duty = row[0] === 'us' ? '' : `<span class="se-duty"><i class="ph-light ph-info" aria-hidden="true"></i>Import duties and taxes, if any, are charged by ${nameOf(cc)}'s customs on delivery and are not included in our prices.</span>`;
      html = `<b>Delivery to ${nameOf(cc)}: ${day(addBD(min))} to ${day(addBD(max))}</b>`
           + `<span>${cost}. Tracked from dispatch${row[0] === 'us' ? '' : `, about ${row[1]} to ${row[2]} business days in transit`}.</span>${duty}`;
    }
    box.innerHTML = `<i class="ph-light ph-truck" aria-hidden="true"></i><span class="se-tx">${html}<span class="se-row">Shipping to ${sel}</span></span>`;
    box.querySelector('[data-se-country]').addEventListener('change', e => {
      try { localStorage.setItem('fr-ship-country', e.target.value); } catch (er) {}
      render(e.target.value);
      window.FRRegion && FRRegion.set(e.target.value);
    });
  };

  let saved = null; try { saved = localStorage.getItem('fr-ship-country') || sessionStorage.getItem('fr-cc'); } catch (e) {}
  if (saved) { render(saved); return; }
  render((window.Shopify && Shopify.country) || 'US');
  fetch('/browsing_context_suggestions.json?country[enabled]=true', { headers: { Accept: 'application/json' } })
    .then(r => r.json()).then(j => { const cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle; if (cc) { render(cc.toUpperCase()); try { sessionStorage.setItem('fr-cc', cc.toUpperCase()); } catch (e) {} } })
    .catch(() => {});
})();
